
import { Dialog, DialogTitle } from '@headlessui/react';
import { FaCheckCircle } from 'react-icons/fa';

import useScrollToTop from '../components/useScrollToTop.js';
import { IoClose } from 'react-icons/io5';
import { IMAGE_URL } from '../config.js';

const TrackingHistoryModal = ({ trackingInfo, modalOpen, setModalOpen }) => {
    useScrollToTop();
    return (
        <Dialog open={modalOpen} onClose={() => setModalOpen(false)} className="relative z-50">
            <div
                transition
                className="fixed inset-0 bg-black bg-opacity-65 transition-opacity duration-500 ease-in-out data-closed:opacity-0"
            />

            <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                    <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                        <Dialog.Panel className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-closed:translate-x-full sm:duration-700"
                        >
                            <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">

                                    <div className="flex items-start justify-between">
                                        <DialogTitle className="text-lg font-bold text-gray-900">Shipment Status & Tracking</DialogTitle>
                                        <div className="ml-3 flex h-7 items-center">
                                            <button
                                                type="button"
                                                onClick={() => setModalOpen(false)}
                                                className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                                            >
                                                <span className="absolute -inset-0.5" />
                                                <span className="sr-only">Close panel</span>
                                                <IoClose aria-hidden="true" className="size-6" />
                                            </button>
                                        </div>
                                    </div>


                                    <div>
                                        {trackingInfo && (
                                            <>
                                                <div className="relative flex flex-col mt-6 items-start space-y-8">
                                                    {trackingInfo?.details && (trackingInfo?.details?.altReferenceNumber || trackingInfo?.details?.destination) && (
                                                        <div className="mb-1 p-4 border border-slate-200 rounded-md bg-slate-50 text-sm min-w-max w-full">
                                                            {/* {trackingInfo?.details?.weight && trackingInfo?.details?.weightUnit && <p><strong>Weight:</strong> {trackingInfo?.details?.weight} {trackingInfo?.details?.weightUnit}</p>} */}
                                                            {trackingInfo?.details?.destination && <p><strong>Destination:</strong> {trackingInfo?.details?.destination}</p>}
                                                            {trackingInfo?.details?.altReferenceNumber && <p><strong>Forwarding No.:</strong> {trackingInfo?.details?.altReferenceNumber}</p>}
                                                        </div>
                                                    )}
                                                    <div className="relative mt-4 pl-1 min-w-max w-full">
                                                        {/* Vertical Line */}
                                                        <div className="absolute left-[15px] top-2 bottom-0 w-[2px] bg-green-400 transition-colors group-hover:bg-black"></div>
                                                        {trackingInfo?.history?.map((event, index) => {
                                                            return (
                                                                <div key={index} className="relative flex items-start gap-4 mb-6 group">
                                                                    <div className="relative flex items-center">
                                                                        <FaCheckCircle className="text-green-500 text-2xl bg-white rounded-full z-10 transition-colors" />
                                                                    </div>
                                                                    <div className="space-y-1 text-xs sm:text-sm">
                                                                        <p className="font-semibold text-gray-900">{event?.event_time}</p>
                                                                        <p className="text-gray-600">{event?.location}</p>
                                                                        <p className="text-gray-700">{event?.message}</p>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    {trackingInfo?.details?.proof_of_delivery && (
                                                        <div className="mb-1 p-4 border border-slate-200 rounded-md bg-slate-50 text-sm min-w-max w-full">
                                                            PROOF OF DELIVERY
                                                            {trackingInfo?.details?.proof_of_delivery?.code_number && (
                                                                <p><strong>COD AMOUNT:</strong> {trackingInfo?.details?.proof_of_delivery?.code_number}</p>
                                                            )}

                                                            {trackingInfo?.details?.proof_of_delivery?.receiver_name && (
                                                                <p><strong>Receiver:</strong> {trackingInfo?.details?.proof_of_delivery?.receiver_name}</p>
                                                            )}

                                                            {trackingInfo?.details?.proof_of_delivery?.receiver_mobile && (
                                                                <p><strong>Mobile:</strong> {trackingInfo?.details?.proof_of_delivery?.receiver_mobile}</p>
                                                            )}

                                                            {trackingInfo?.details?.proof_of_delivery?.photo_url && (
                                                                <div className="my-2">
                                                                    <strong>Photo:</strong>
                                                                    <a
                                                                        href={`${IMAGE_URL}/${trackingInfo?.details?.proof_of_delivery?.photo_url}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        <img
                                                                            src={`${IMAGE_URL}/${trackingInfo?.details?.proof_of_delivery?.photo_url}`}
                                                                            alt="POD Photo"
                                                                            className="w-28 h-28 object-cover border mt-1 cursor-pointer"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            )}

                                                            {trackingInfo?.details?.proof_of_delivery?.signature_url && (
                                                                <div className="my-2">
                                                                    <strong>Signature:</strong>
                                                                    <a
                                                                        href={`${IMAGE_URL}/${trackingInfo.details.proof_of_delivery.signature_url}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        <img
                                                                            src={`${IMAGE_URL}/${trackingInfo.details.proof_of_delivery.signature_url}`}
                                                                            alt="Signature"
                                                                            className="w-28 h-28 object-cover border mt-1 cursor-pointer"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}

                                                    {trackingInfo?.details?.last_center_details && (
                                                        <div className="mb-1 p-4 mt-4 border border-slate-200 rounded-md bg-slate-50 text-sm min-w-max w-full">
                                                            <p className="font-semibold mb-1">LAST CENTER DETAILS</p>

                                                            {trackingInfo?.details?.last_center_details?.fullName && (
                                                                <p><strong>Name:</strong> {trackingInfo?.details?.last_center_details?.fullName}</p>
                                                            )}

                                                            {trackingInfo?.details?.last_center_details?.contactNo && (
                                                                <p><strong>Contact:</strong> {trackingInfo?.details?.last_center_details?.officeTelephoneNo}</p>
                                                            )}

                                                            {trackingInfo?.details?.last_center_details?.alternateContactNo && (
                                                                <p><strong>Alternate Contact:</strong> {trackingInfo?.details?.last_center_details?.alternateContactNo}</p>
                                                            )}

                                                            {trackingInfo?.details?.last_center_details?.email && (
                                                                <p><strong>Email:</strong> {trackingInfo?.details?.last_center_details?.email}</p>
                                                            )}

                                                            {trackingInfo?.details?.last_center_details?.officeAddress && (
                                                                <p><strong>Address:</strong> {trackingInfo?.details?.last_center_details?.officeAddress}</p>
                                                            )}

                                                            {trackingInfo?.details?.last_center_details?.officeCity && (
                                                                <p><strong>City:</strong> {trackingInfo?.details?.last_center_details?.officeCity}</p>
                                                            )}

                                                            {trackingInfo?.details?.last_center_details?.officeState && (
                                                                <p><strong>State:</strong> {trackingInfo?.details?.last_center_details?.officeState}</p>
                                                            )}

                                                            {trackingInfo?.details?.last_center_details?.officePincode && (
                                                                <p><strong>Pincode:</strong> {trackingInfo?.details?.last_center_details?.officePincode}</p>
                                                            )}

                                                            {trackingInfo?.details?.last_center_details?.district && (
                                                                <p><strong>District:</strong> {trackingInfo?.details?.last_center_details?.district}</p>
                                                            )}
                                                        </div>
                                                    )}

                                                </div>
                                            </>
                                        )
                                        }
                                    </div >
                                </div>
                            </div>
                            <div className="bg-slate-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                <button
                                    type="button"
                                    onClick={() => setModalOpen(false)}
                                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-slate-50 sm:mt-0"
                                >
                                    Cancel
                                </button>
                            </div>
                        </Dialog.Panel >
                    </div>
                </div >
            </div >
        </Dialog >

    );
};

export default TrackingHistoryModal;
